const mod = require('../../bahabot.module.js')

function bbLogsController(EventSourceService, $scope, $timeout) {
    this.stream = null;
    this.subscriptions = [];
    this.messages = [];
    this.size = 100;

    this.$onInit = () => {
        this.stream = EventSourceService.connect("/api/protected/logs/live", true)
        let init = true;
        $timeout(() => {
            init = false;
            $scope.bottom[0].scrollIntoView({
                behavior: 'smooth'
            });
        }, 200)

        const offMessage = this.stream.on('append', (data) => {
            this.messages.push(data);

            if (!init) {
                $timeout(() => {
                    $scope.bottom[0].scrollIntoView({
                        behavior: 'smooth'
                    });
                }, 50);
            }

            while (this.messages.length > this.size) this.messages.shift();
        })

        this.subscriptions = [
            offMessage,
        ]
    }

    this.$onDestroy = () => {
        for (const unregister of this.subscriptions) {
            unregister();
        }
        this.subscriptions = [];
        this.messages = [];
        this.stream?.close();
        this.stream = null;
    }
}

mod.component('bbLogs', {
    templateUrl: 'tpl/bb-logs.component.html',
    bindings: {},
    controller: ["EventSourceService", "$scope", "$timeout", bbLogsController]
});